import Modal from 'components/shared/Modal/Modal';

import PastImportsTable from './PastImportsTable';

const PastImportsModal = ({ isOpen, handleClose, onViewPastImport }) => {
  return (
    <Modal
      title="Past imports"
      handleClose={handleClose}
      isOpen={isOpen}
      slideFromRight
      isLarge
      className="!w-[60%]">
      <PastImportsTable onViewPastImport={onViewPastImport} />
    </Modal>
  );
};

export default PastImportsModal;
